import './style.css'
import { useContext, useEffect, useState } from "react";
import CustomTable from "../../Components/CustomTable";
import { DashboardLayout } from "../../Layout/DashboardLayout"
import { Dropdown, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEllipsisV, faTimes } from "@fortawesome/free-solid-svg-icons";
import { disabledButtonByPermission } from "../../Components/Permissions";
import { PermissionsContext } from "../../Layout/PermissionContext";
import CustomInput from "../../Components/CustomInput";
import BASEURL from "../../Config/global";
import axios from "axios";
import { deleteRequest, patchRequest, postRequest, putRequest } from "../../Util/requests";
import { questionModal, successModal } from "../../Components/CustomModal";
import moment from "moment";


const MobileVersionManagement =()=>{
    const { permissions } = useContext(PermissionsContext)
    const [swapInputError, setInputError] = useState({ error: true, text: '' });
    const [showSwapModal, setShowSwapModal] = useState(false);
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({});
    const [editId, setEditId] = useState("");
    useEffect(() => {
        fetchData()
    }, [])

    async function fetchData() {
        try {

            const response = await axios.get(
                `${BASEURL}/api/user/admin_side_mobile_versions`
            );
            if (response.data.error !== true) {
                // console.log(response.data.data);
                setData(response.data.data);
                // setPlatformList(response.data.count);
            } else {
                console.log(response.data.message);
            }
        } catch (error) {
            console.error(error);
        }
    }
    
    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
        setInputError({error:false, text:''})

    };

    const updateOrAddCategory = async () => {
        const { android_version, ios_platform } = formData;
        if (!android_version || !ios_platform) {
            setInputError({ error: true, text: 'Please fill all fields' });
            return;
        }
        questionModal
            .fire({
                title: `Do you want to ${editId ? "update" : "add"} this Mobile Version?`,
                confirmButtonText: editId ? "Update" : "Add",
            })
            .then(async (result) => {
                if (result.isConfirmed) {
                    await postData().then(async () => {
                        setEditId("");
                        setShowSwapModal(false);
                        setFormData({});
                        setInputError({ error: false, text: '' });
                        successModal.fire({
                            text: "Mobile version added successfully",
                            confirmButtonText: "Continue",
                        });
                        await fetchData()
                    }).catch(error => {
                        console.log("error", error)
                    });

                }
            });
    };
      

    const postData = async () => {
        try {
            const { android_version, ios_platform } = formData;
            const raw = JSON.stringify({
                android_version,
                ios_platform
              });
            if (editId) {
                const URL = `/api/user/admin_side_mobile_versions/${editId ? editId : ''}`
                return await patchRequest(URL, raw);
            } else {
                const URL = `/api/user/admin_side_mobile_versions`
                return await postRequest(URL, raw);
            }
        } catch (error) {
            console.error(error);
        }
    };
    const couponsHeader = [
        { key: "sr", title: "SR" },
        { key: "date", title: "Date" },
        { key: "android_version", title: "Android Version" },
        { key: "ios_platform", title: "iOS Version" },
        { key: "actions", title: "Actions" },
      ];
    const modulesWisePermission = (condition) => {
        if (!permissions) {
            return 'd-none'
        }
        return disabledButtonByPermission(permissions, condition)
    }
    const handleDeleteItemCallBack = async (item) => {
        questionModal
            .fire({
                title: "Do you want to delete this Mobile Version",
                confirmButtonText: "Delete",
            })
            .then(async (result) => {
                if (result.isConfirmed) {
                    await deleteRequest(`/api/user/admin_side_mobile_versions/${item.id}`)
                        .then(() => {
                            setData([...data.filter((p, i) => p.id !== item.id)]);
                            successModal.fire({
                                text: "Mobile version deleted successfully",
                                confirmButtonText: "Continue",
                            });
                        })
                        .catch((error) => console.error(error));
                }
            });
    }

    const AppVersions = () => {
        if (data?.length === 0) {
            return;
        }
        const { android_version=1, ios_platform=1 } = data[0]
        return (
           <div className='row'>
             <div className="col-3 ">
              <div className='d-flex flex-row justify-content-start align-items-center mt-2'>
              <p className='mainLabel text-nowrap mt-1'>iOS Current Version: </p><strong  className='mx-2 w-25 '>{ios_platform}</strong>
              </div>
              <div className='d-flex flex-row justify-content-start align-items-center mt-2'>
              <p className='mainLabel text-nowrap mt-1'>Android Current Version: </p><strong className='mx-2 w-25 '>{android_version}</strong>
              </div>
                {/* <p>🤖 Android Current Version: </p> <input value={android_version} className='mx-2'/> */}
            </div>
           </div>
        )
    };
    return (<DashboardLayout>
        <div className="row mb-3">
            <div className="col-lg-8 mb-2">
                <h2 className="mainTitle">Mobile Versions </h2>
            </div>
            <div className="col-lg-4 text-end mb-2">
                <button
                    onClick={() => {
                        setEditId("")
                        setShowSwapModal(true)
                        setInputError({ error: false, text: '' })
                        setFormData({})
                    }}
                    className={`customButton primaryButton `}
                >
                    Add Version
                </button>
            </div>
        </div>
        {

            <div className="col-12">
                <AppVersions />
                <CustomTable headers={couponsHeader}>
                    <tbody>
                        {data && data?.length > 0 &&
                            data.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>

                                    <td>
                                        {
                                            moment(item?.created).format('MM-DD-YYYY')
                                        }

                                    </td>
                                    <td >{item.android_version}</td>
                                    <td >{item.ios_platform}</td>

                                    <td>
                                        <Dropdown className="tableDropdown">
                                            <Dropdown.Toggle
                                                variant="transparent"
                                                className="notButton classicToggle"
                                            >
                                                <FontAwesomeIcon icon={faEllipsisV} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu
                                                align="end"
                                                className="tableDropdownMenu"
                                            >
                                                {/* <button
                                                    onClick={() => {
                                                        setEditId(item.id)
                                                        setFormData({
                                                          android_version: item.android_version,
                                                          ios_platform: item.ios_platform,
                                                        });
                                                        setShowSwapModal(true);
                                                      }}
                                                    className={`tableAction Button `}
                                                    // className={`tableAction Button ${modulesWisePermission("can_edit")}`}

                                                >
                                                    <FontAwesomeIcon
                                                        icon={faEdit}
                                                        className="tableActionIcon"
                                                    />
                                                    Edit
                                                </button> */}

                                                <button
                                                    className={`tableAction`}

                                                    // className={`tableAction ${modulesWisePermission("can_delete")}`}
                                                    onClick={() => {
                                                        handleDeleteItemCallBack(item, index);
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faTimes}
                                                        className="tableActionIcon"
                                                    />
                                                    Delete
                                                </button>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </CustomTable>
            </div>
        }
        <Modal
            show={showSwapModal}
            centered
            className="swap-modal"
            backdrop="static"
        >
            <Modal.Body>
                <div className="pb-5 w-100 d-flex flex-column align-items-center">
                    <div className="d-flex justify-content-between w-100  ">
                        <h2 className="mainTitle">{editId !== "" ? "Edit" : "Add"} Mobile Version Details</h2>
                        <div className="text-end ms-auto">
                            <button
                                className="closeButton notButton ms-auto"
                                onClick={() => {
                                    setEditId("")
                                    setShowSwapModal(false)
                                    setInputError({ error: false, text: '' })

                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="cross-icon"
                                    color="white"
                                />
                            </button>
                        </div>
                    </div>
                    <br />

                    <div className="row w-100 mb-3">
                        
                        <div className='col-12 mt-auto '>
                            <CustomInput
                                label="Android Version"
                                labelClass="mainLabel"
                                required
                                type="text"
                                name="android_version"
                                value={formData?.android_version || ""}
                                placeholder="Enter Android Version"
                                inputClass="mainInput"
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className='row w-100'>
                        <div className="col-12">
                            <CustomInput
                                label="iOS Version"
                                labelClass="mainLabel"
                                type="text"
                                required
                                name="ios_platform"
                                value={formData?.ios_platform || ""}
                                placeholder="Enter iOS Version"
                                inputClass="mainInput"
                                onChange={handleChange}
                            />

                        </div>
                    </div>


                    {swapInputError?.error && <small className="text-danger mt-3">{swapInputError.text}</small>}
                    <div className=" pt-5 d-flex gap-3 justify-content-center">
                        <button style={{ backgroundColor: '#ffffff1f' }} className='px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={updateOrAddCategory}>
                            <span className=''>{editId !== "" ? "UPDATE" : "Add"}</span>
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </DashboardLayout>)
}

export default MobileVersionManagement